module.exports = __webpack_public_path__ + "img/191.071a28dc.jpg";